(function ($, window, document, undefined) {

  'use strict';

  $(function () {
	  $.expose = {};